module.exports = "<iframe class=\"scormFrame\" style=\"width: 100%; height: 100%;\" onload=\"synUtil_endAjaxProgress();\"></iframe>";